<script>
export default {
  name: 'ReportFavorite',
  props: {
    reportName: { required: true, type: String },
    reportParameters: { type: Object },
    chartType: { type: String }
  },
  data() {
    return {
      favoriteName: '',
      favoriteWithOptions: true,
      favoriteWithChart: true
    }
  },
  methods: {
    saveToFavorites() {
      let parameters = {}
      if (this.favoriteWithOptions) {
        parameters.filters = this.reportParameters
      }
      if (this.chartType && this.chartType != '' && this.favoriteWithChart) {
        parameters.chartType = this.chartType
      }
      this.graphql(
        /* GraphQL */ `
          mutation ReportSaveFavMutation(
            $reportName: String!
            $favName: String!
            $favOptions: JSON
          ) {
            createMetricsDashFav(
              input: {
                metricsDashFav: {
                  reportName: $reportName
                  favOptions: $favOptions
                  favName: $favName
                }
              }
            ) {
              clientMutationId
            }
          }
        `,
        {
          reportName: this.reportName,
          favName: this.favoriteName,
          favOptions: JSON.stringify(parameters) != '{}' ? parameters : null
        }
      ).then(() => {
        this.$root.$emit('refresh-nav') // make sure the favorites shows up in the menu
      })
    }
  },
  mounted() {
    this.favoriteName = this.reportName
  }
}
</script>

<template>
  <b-modal
    id="save-to-favorites-modal"
    title="Save to Favorites"
    @ok="saveToFavorites"
  >
    <b-form-group
      label-cols-lg="4"
      label-for="favoriteName"
      class="form-field-group"
      label-class="font-weight-bold pb-0"
      label="Favorite Name"
    >
      <b-input-group>
        <b-form-input
          v-model="favoriteName"
          name="favoriteName"
          autocomplete="off"
        />
      </b-input-group>
    </b-form-group>
    <b-form-group
      label-cols-lg="8"
      label-for="favoriteWithOptions"
      class="form-field-group"
      label-class="font-weight-bold pb-0"
      label="Save with Search Parameters"
    >
      <b-input-group>
        <b-form-checkbox
          v-model="favoriteWithOptions"
          name="favoriteName"
          autocomplete="off"
        />
      </b-input-group>
    </b-form-group>
    <b-form-group
      label-cols-lg="8"
      label-for="favoriteWithChart"
      class="form-field-group"
      label-class="font-weight-bold pb-0"
      label="Save with Selected Chart Type"
      v-if="chartType && chartType != ''"
    >
      <b-input-group>
        <b-form-checkbox
          v-model="favoriteWithChart"
          name="favoriteName"
          autocomplete="off"
        />
      </b-input-group>
    </b-form-group>
  </b-modal>
</template>
